export enum ScreenSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}
